import { TYPES } from "./types";
import { tkt1ProductService } from "../services"; 

export const getTKT1Products = (query) => async (dispatch) => {
  try {
    const result = await tkt1ProductService.getProducts(query);
    console.log('[Debug] TKT1 Product API Response:', result.data);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PRODUCTS_SUCCESS,
        payload: data,
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PRODUCTS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1ProductByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1ProductService.getProductByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PRODUCT_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PRODUCT_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1ProductByMID = (mid) => async (dispatch) => {
  try {
    const result = await tkt1ProductService.getProductByMID(mid);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PRODUCT_BY_MID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_PRODUCT_BY_MID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1Product = (productData) => async (dispatch) => {
  try {
    const result = await tkt1ProductService.createProduct(productData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_PRODUCT_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_PRODUCT_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1Product = (id, productData) => async (dispatch) => {
  try {
    const result = await tkt1ProductService.updateProduct(id, productData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_PRODUCT_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_PRODUCT_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1ProductByMID = (mid, productData) => async (dispatch) => {
  try {
    const result = await tkt1ProductService.updateProductByMID(mid, productData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_PRODUCT_BY_MID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_PRODUCT_BY_MID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1Product = (id) => async (dispatch) => {
  try {
    const result = await tkt1ProductService.deleteProduct(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_PRODUCT_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_PRODUCT_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1Products = (searchQuery) => async (dispatch) => {
  try {
    const result = await tkt1ProductService.searchProducts(searchQuery);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_PRODUCTS_SUCCESS,
        payload: data,
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_PRODUCTS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1ProductAction = {
  getTKT1Products,
  getTKT1ProductByID,
  getTKT1ProductByMID,
  createTKT1Product,
  updateTKT1Product,
  updateTKT1ProductByMID,
  deleteTKT1Product,
  searchTKT1Products
};
